import React from 'react';
import ReactDOM from 'react-dom/client'
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Store from './redux/Store';
import 'bootstrap/dist/css/bootstrap.min.css';

import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './common/Utils/msalUtils';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <MsalProvider instance={msalInstance}>
        <Provider store={Store}>
          <App />
        </Provider>
      </MsalProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
